module.exports = __webpack_public_path__ + "img/logo_dessert.9e8ca014.png";